import { SxProps } from '@mui/material'

import { headerClasses, headerDimensions } from './Header.data'

interface HeaderStyles {
  header: SxProps
  headerColorOverlay: SxProps
  headerGradient: SxProps
  containerWrapper: SxProps
  container: SxProps
  leftContent: SxProps
  configLogo: {
    root: SxProps
    desktop: SxProps
    mobile: SxProps
  }
}

export const headerStyles: HeaderStyles = {
  header: {
    height: headerDimensions.height,
    backgroundColor: 'utils.gray950',
    boxShadow: 'none',
    position: 'relative',

    // Main Logo
    [`.${headerClasses.logo}`]: {
      width: {
        xs: headerDimensions.logo.stackedIconMobile,
        md: headerDimensions.logo.desktop,
      },
      color: 'pageTheme.secondaryColor',
      display: { xs: 'none', lg: 'block' },
    },

    // Stacked Icon (Mobile) Visible on Mobile, Hidden on Desktop
    [`.${headerClasses.logoStackedIcon}`]: {
      width: { xs: headerDimensions.logo.stackedIconMobile },
      color: 'pageTheme.secondaryColor',
      display: { xs: 'block', lg: 'none' },
    },

    // Icon Only (Mobile) Visible on Mobile in Package workflow only, Hidden on Desktop
    [`.${headerClasses.logoIcon}`]: {
      width: { xs: headerDimensions.logo.iconMobile },
      color: 'pageTheme.secondaryColor',
      display: 'none',
    },

    // Package workflow specific styles
    [`&.${headerClasses.package}`]: {
      [`.${headerClasses.logoStackedIcon}`]: {
        display: { xs: 'none' },
      },
      [`.${headerClasses.logoIcon}`]: {
        display: { xs: 'block', lg: 'none' },
      },
      [`.${headerClasses.logoFanatics}`]: {
        display: { xs: 'none', lg: 'block' },
      },
      [`.${headerClasses.logoFanaticsIcon}`]: {
        display: { xs: 'block', lg: 'none' },
      },
    },

    // Fanatics full logo — desktop + mobile non-package
    [`.${headerClasses.logoFanatics}`]: {
      display: 'block',
      width: {
        xs: headerDimensions.logo.mobile + 10,
        lg: headerDimensions.logo.desktop,
      },
    },

    // Fanatics icon-only — hidden by default, shown on mobile in package workflow
    [`.${headerClasses.logoFanaticsIcon}`]: {
      display: 'none',
      width: headerDimensions.logo.iconMobile,
      color: 'pageTheme.secondaryColor',
    },

    // Landing page specific styles
    [`&.${headerClasses.transparent}`]: {
      position: 'absolute',
      backgroundColor: 'transparent',
    },
  },
  headerColorOverlay: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    inset: 0,
    color: 'transparent',
    zIndex: 0,
  },
  headerGradient: {
    '&::after': {
      position: 'absolute',
      height: '100%',
      width: '100%',
      content: '""',
      top: 0,
      left: 0,
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.50) 100%)',
    },
  },
  containerWrapper: {
    zIndex: 1,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%',
    gap: headerDimensions.gap,
  },
  leftContent: {
    display: 'flex',
    gap: 6,
    alignItems: 'center',
    height: '100%',
  },
  configLogo: {
    root: {
      height: 34,
      width: 'auto',
      [`.${headerClasses.configLogoImage}`]: { height: '100%', width: 'auto' },
    },
    desktop: {
      display: { xs: 'none', lg: 'block' },
    },
    mobile: {
      display: { xs: 'block', lg: 'none' },
    },
  },
}
